module.exports = __webpack_public_path__ + "img/Play.ccca52cb.svg";